export const ROLE_SLUGS = {
  EXEC_ADMIN: 'milipot-executive-admin',
  SUPER_ADMIN: 'super-admin',
  USER: 'user',
};

export const PERMISSION_SLUGS = {
  VIEW_PARTNER_DASHBOARD:         'view-partner-dashboard',
  VIEW_PARTNER_STATEMENTS:        'view-partner-statements',
  EXPORT_PARTNER_STATEMENTS:      'export-partner-statements',
  VIEW_PARTNER_DETAILS:           'view-partner-details',
  MANAGE_TEAMS:                   'manage-teams',
  MANAGE_EXPENSE_TAGS:            'manage-expense-tags',
  MANAGE_RECEIPTS:                'manage-receipts',
  MANAGE_PARTNER_USERS:           'manage-partner-users',
  ASSIGN_USER_ROLES_PERMISSIONS:  'assign-user-roles-and-permissions',
  CHANGE_USER_ROLE:               'change-user-role',
  MANAGE_USER_TRANSACTION_LIMITS: 'manage-user-transaction-limits',
  INITIATE_VAULT_TOP_UPS:         'initiate-vault-top-ups',
  INITIATE_WALLET_DISBURSEMENTS:        'initiate-wallet-disbursements',
  REVIEW_WALLET_DISBURSEMENT_REQUESTS:  'review-wallet-disbursement-requests',
  CAN_REVIEW_APPROVALS:                 'can-review-approvals',
  REVIEW_LIMIT_EXTENSION_REQUESTS:      'review-limit-extension-requests',
  VERIFY_KYC_DOCUMENTS:           'verify-kyc-documents',
};

// Permissions whose actions move money on the backend and therefore require
// the caller to authorise with their transaction PIN. Anyone holding one of
// these permissions must set a PIN, whether or not they hold a wallet.
export const PERMISSIONS_REQUIRING_TRANSACTION_PIN = [
  PERMISSION_SLUGS.INITIATE_WALLET_DISBURSEMENTS,
];

// True when the viewer will be asked for a transaction PIN somewhere in the
// app: either because they hold an active wallet (their own payouts) or
// because they hold a permission that moves money for others (topping up
// user wallets). An inactive wallet is deliberately excluded, not an
// oversight: the holder cannot transact until it is reactivated, so PIN
// nudges, the expiry banner, the sidebar Change PIN and Forgot PIN items,
// and the walkthrough PIN steps all stay hidden while a wallet is paused.
// If a suspended user needs to rotate a compromised PIN in the meantime,
// they contact support or wait for reactivation; the moment the wallet
// reactivates, this predicate flips on and every PIN surface returns. Do
// not widen the wallet check back to has_wallet without a matching decision
// on that trade-off, since the pre-change code had this exact broader gate
// on some sites and it was silently inconsistent with the narrower gate on
// the sidebar and walkthrough.
export const userNeedsTransactionPin = (authUser) => {
  if (!authUser) return false;
  if (authUser.has_active_wallet) return true;
  const grantedPermissions = authUser.all_permission_slugs ?? [];
  return PERMISSIONS_REQUIRING_TRANSACTION_PIN.some((slug) => grantedPermissions.includes(slug));
};
